import { CssType, ThemeType } from 'src/theme/jss-types';

export const ReceivablesRequestActionStyles = (theme: ThemeType): CssType => ({
  modal: {
    maxWidth: '408px',
  },
  label: {
    fontSize: '12px',
    color: '#333333',
    fontWeight: 600,
    marginTop: '8px',
  },
  button: {
    borderRadius: '4px !important',
    padding: '0px 16px !important',
    marginLeft: '16px !important',
    fontSize: '14px',
  },
  drawerTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  inputStyle: {
    borderRadius: '3px',
    border: '1px solid #D9D9D9',
    width: '240px',
    marginLeft: '30px',
    textTransform: 'uppercase',
  },
  dragger: {
    boxSizing: 'border-box',
    color: 'rgba(0, 0, 0, 0.85)',
    fontSize: '14px',
    fontVariant: 'tabular-nums',
    lineHeight: 2,
    fontFeatureSettings: 'tnum',
    outline: 0,
    marginTop: '50px',
    marginRight: '15px',
    marginLeft: '15px',
  },
  detailsContainer: {
    padding: '5px',
    flex: '0.1 1 0%',
    display: 'flex',
    flexDirection: 'column',
  },
  divFlex: {
    display: 'flex',
    padding: '0px',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  hint: {
    fontSize: '12px',
    margin: '1px 0',
  },
  content: {
    fontSize: '13px',
    color: '#262626',
    fontWeight: 500,
    textTransform: 'uppercase',
    marginBottom: '8px',
  },
  commentsDetailsDataContainer: {
    padding: '10px',
    marginLeft: '10px',
    marginRight: '10px',
    display: 'flex',
    flexDirection: 'column',
    fontSize: '12px',
  },
  commentsDetailsDataHeaderContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  commentsDetailsDataCommentContainer: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: '13px',
    fontWeight: 300,
  },
  timeStamp: {
    marginRight: '2px',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  commentsTrackingContainer: {
    marginRight: '8px',
    flex: '0.75 1 0%',
    display: 'flex',
    marginTop: '10px',
    position: 'relative',
    border: '1px solid #ccc',
    borderRadius: '5px',
    maxHeight: '60vh',
    overflow: 'auto',
    minHeight: '200px',
  },
  commentsContainer: {

  },
  titleClose: {
    marginRight: '15px',
  },
  titleHeading: {
    fontSize: '15px',
  },
  commentsTabpane: {
    padding: '5px',
  },
  commentsTabContainer: {
    '& .ant-tabs-nav-list': {
      width: '100%',
    },
    '& .ant-tabs-tab': {
      width: '50%',
      justifyContent: 'center',
      fontSize: '14px',
      lineHeight: '1.5715',
    },
  },
  commentButton: {
    position: 'absolute',
  },
  commentBorder: {
    position: 'relative',
    border: '1px solid #ccc',
    padding: '10px',
    borderRadius: '5px',
    height: '140px',
    marginTop: '8px',
    marginRight: '10px',
  },
  fileCard: {
    margin: '10px 0',
    marginRight: '10px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    display: 'flex',
    height: '60px',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  fileInfo: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '10px',
  },
  fileDownload: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '20px',
    marginRight: '10px',
    '& .anticon': {
      color: 'grey',
    },
  },
  fileIcon: {
    fontSize: '28px',
    color: 'grey',
    marginLeft: '10px',
    marginRight: '10px',
    height: '80%',
  },
  fileDetails: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '28px',
    marginLeft: '8px',
  },
  fileName: {
    fontSize: '11px',
  },
  fileUploader: {
    fontSize: '13px',
    marginRight: '5px',
    color: 'grey',
  },
  separator: {
    marginLeft: '3px',
    marginRight: '3px',
    color: 'grey',
  },
  rectangleTrackInfo: {
    flexGrow: 1,
    border: '1px solid #D9D9D9',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    padding: '5px',
    marginTop: '10px',
    marginRight: '10px',
    height: '80vh',
  },
  timelineTail: {
    minHeight: 60,
    '& .ant-timeline-item-tail': {
      borderLeft: '2px dotted #0C7AF9',
    },
    '& .ant-timeline-item-head-custom': {
      top: '13.5px',
      padding: 0,
    },
  },
  timelineTailHide: {
    minHeight: 0,
    '& .ant-timeline-item-tail': {
      borderLeft: '0px solid #E8E8E8',
    },
  },
  trackStatus: {
    fontSize: '14px',
    fontWeight: 300,
  },
});
